import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_DEDUCTION_REQUEST = "POST_DEDUCTION_REQUEST";
export const POST_DEDUCTION_SUCCESS = "POST_DEDUCTION_SUCCESS";
export const POST_DEDUCTION_ERROR = "POST_DEDUCTION_ERROR";

//* ACTIONS ------------------------------------------------
export const postDeductionRequest = (payload = {}, callback) => ({
  type: POST_DEDUCTION_REQUEST,
  payload,
  callback,
});

export const postDeductionSuccess = () => ({
  type: POST_DEDUCTION_SUCCESS,
});

export const postDeductionError = (error) => ({
  type: POST_DEDUCTION_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postDeductionServiceRequest = async (data) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data,
  });

  return request("/employee/deductions", options);
};
